<template>
  <multiselect
      class="ui-multiselect"
  :value="value"
  :label="label"
  :custom-label="customLabel"
  :track-by="trackBy"
  :options="options"
  :multiple="multiple"
  :taggable="taggable"
  :allow-empty="allowEmpty"
  :close-on-select="closeOnSelect"
  :clear-on-select="clearOnSelect"
  :disabled="disabled"
  @tag="tag"
  @input="input"

  :placeholder="placeholderText"
  tag-placeholder=""
  select-label=""
  selected-label=""
  deselect-label=""
  >
    <span slot="noResult">{{ $t('modules.shop.messages.filter-no-result') }}</span>
  </multiselect>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  export default {
    components: {
      Multiselect
    },
    props: [
      'value',
      'label',
      'customLabel',
      'track-by',
      'options',
      'multiple',
      'taggable',
      'allow-empty',
      'close-on-select',
      'clear-on-select',
      'disabled',
      'placeholder'
    ],
    computed: {
      placeholderText () {
        if (this.value && this.value.length !== 0) return ''
        return this.placeholder || ''
      }
    },
    methods: {
      tag (...args) {
        this.$emit('tag', ...args)
      },
      input (...args) {
        this.$emit('input', ...args)
      }
    }
  }
</script>

<style lang="scss" type="text/scss">
  .ui-multiselect {
    .multiselect__tags {
      border-radius: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// client/components/ui/multiselect.vue